<admin-panel-ocr [title]="getDefinition().config?.description!" (selected)="onUpload($event)">
  <ng-container *ngIf="getDefinition().config?.vertical == 'wlm'">
    <ng-container *ngFor="let field of getFields()">
      <div [hidden]="field.config!.hash == undefined" class="row">
        <div style="width: 90%">
          <div class="text-muted small mb-1">{{field.name}}&nbsp;value</div>
          <div class="fw-bold text-dark"><input [(ngModel)]="field.value" [placeholder]="'common.text.type_here' | translate" id="check-value" type="text" class="mb-6 form-control border border-dark-3"></div>
        </div>
        <div style="width: 10%">
          <div class="text-muted small mb-1">{{'pages.lookup.field_list.threshold' | translate}} %</div>
          <div class="fw-bold text-dark"><input [(ngModel)]="field.params.threshold" placeholder="" id="threshold" type="text" class="mb-6 form-control border border-dark-3"></div>
        </div>
<!--      <div style="width: 5%" class="text-center">-->
<!--        <div class="text-muted small mb-1">&nbsp;</div>-->
<!--        <div smartTooltip class="tooltip-wrapper weight-label">-->
<!--          <a class="text-decoration-none text-purple mt-2"><i class="bi bi-info-circle"></i></a>-->
<!--          <div class="dropdown-menu tooltip-box">-->
<!--            <table class="list-unstyled text-left text-nowrap">-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.field_name' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-semibold text-info col-6">{{ field.config?.name }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.data_type' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info col-6">{{ field.config?.dataType }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.ngram_size' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info col-6">{{ field.config?.ngram }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.block_size' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info">{{ field.config?.bands }}x{{ field.config?.rows }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.hash_type' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info">{{ field.config?.hash }}</span></td>-->
<!--              </tr>-->
<!--            </table>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="getDefinition().config?.vertical == 'cdd'">
    <div *ngFor="let field of getFields()" class="row">
      <div style="width: 100%">
        <div class="text-muted small mb-1">{{field.name}}</div>
        <div class="fw-bold text-dark"><input [(ngModel)]="field.value" [placeholder]="'common.text.type_here' | translate" id="rule-value" type="text" class="mb-6 form-control border border-dark-3"></div>
      </div>
<!--      <div style="width: 5%" class="text-center" *ngIf="field.config?.hash && field.config?.hash != 'none'">-->
<!--        <div class="text-muted small mb-1">&nbsp;</div>-->
<!--        <div smartTooltip class="tooltip-wrapper weight-label">-->
<!--          <a class="text-decoration-none text-purple mt-2"><i class="bi bi-info-circle"></i></a>-->
<!--          <div class="dropdown-menu tooltip-box">-->
<!--            <table class="list-unstyled text-left text-nowrap">-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.field_name' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-semibold text-info col-6">{{ field.config?.name }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.data_type' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info col-6">{{ field.config?.dataType }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.ngram_size' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info col-6">{{ field.config?.ngram }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.block_size' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info">{{ field.config?.bands }}x{{ field.config?.rows }}</span></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="text-end col-5"><span class="text-muted">{{'pages.lookup.hash_type' | translate}}:</span></td>-->
<!--                <td class="text-start"> <span class="text-info">{{ field.config?.hash }}</span></td>-->
<!--              </tr>-->
<!--            </table>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </ng-container>
</admin-panel-ocr>
